import React, { useState } from "react";
import { auth } from "../firebase";
import { Link } from "@reach/router";
import {
  Alert,
  Box,
  Button,
  Card,
  CardContent,
  TextField,
  Typography,
} from "@mui/material";
import { palette } from "../theme";

const PasswordReset = () => {
  const [email, setEmail] = useState("");
  const [emailHasBeenSent, setEmailHasBeenSent] = useState(false);
  const [error, setError] = useState(null);

  const sendResetEmail = (event) => {
    event.preventDefault();
    auth
      .sendPasswordResetEmail(email)
      .then(() => {
        setEmailHasBeenSent(true);
        setError(null);
      })
      .catch(() => {
        setError("Couldn't send the reset email — check the address and try again.");
      });
  };

  return (
    <Box sx={{ px: 2, py: { xs: 4, md: 8 }, display: "flex", justifyContent: "center" }}>
      <Card sx={{ width: "100%", maxWidth: 440 }}>
        <CardContent sx={{ p: { xs: 3, md: 4 } }}>
          <Typography variant="h4" sx={{ textAlign: "center", mb: 1 }}>
            Reset your password
          </Typography>
          <Typography
            variant="body2"
            sx={{ textAlign: "center", color: palette.textSecondary, mb: 3 }}
          >
            We'll email you a link to set a new password
          </Typography>

          {emailHasBeenSent && (
            <Alert severity="success" sx={{ mb: 2 }}>
              An email has been sent to you!
            </Alert>
          )}
          {error !== null && (
            <Alert severity="error" sx={{ mb: 2 }} onClose={() => setError(null)}>
              {error}
            </Alert>
          )}

          <form onSubmit={sendResetEmail}>
            <Box sx={{ display: "flex", flexDirection: "column", gap: 2.5 }}>
              <TextField
                required
                fullWidth
                type="email"
                label="Email Address"
                autoComplete="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
              />
              <Button type="submit" fullWidth size="large" variant="contained" color="secondary">
                Send me a reset link
              </Button>
            </Box>
          </form>

          <Typography variant="body2" sx={{ textAlign: "center", mt: 3 }}>
            <Link to="/sign-in" style={{ fontWeight: 700 }}>
              &larr; Back to sign in
            </Link>
          </Typography>
        </CardContent>
      </Card>
    </Box>
  );
};

export default PasswordReset;
